import React, { useState, useEffect } from "react";

import { Box } from "@mui/material";
import { NavLink,useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { config } from "../../config";
import { PAWPRINT_USER_ROLE_KEY } from "../../Constant";
import useAuth from "../../ContextProvider/AuthProvider";
import DetailsModal from "../Common/DetailsModal";
import Header from "../Header/Header";
import ReactGA from "react-ga4";
import { useTheme } from "@mui/material/styles";
import { ReactComponent as CloseIcon } from "../../Assets/Images/Sidebar/closeIcon.svg";
import { getCategoryDocument } from "../../../api/axios";
import downArrow from "../../Assets/Images/Sidebar/down.svg";

function Sidebar() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [open, setOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const savedDropdown = searchParams.get("categoryId");    
  const [openDropdown, setOpenDropdown] = useState(savedDropdown ? "Documents" : null);

  let role;
  const { sidebar } = config;

  const { user, partner } = useAuth();
  role =
    user?.isSuperUser === "true"
      ? "SuperUser"
      : localStorage.getItem(PAWPRINT_USER_ROLE_KEY);


  
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getCategoryDocument();
        setCategories(response?.data?.data || []);
      } catch (error) {
        console.error('Error fetching categories:', error);
        setCategories([]);
      }
    };
    fetchCategories();
  }, []);



  let SidebarItems = sidebar.filter((item) => item.roles.includes(role));
  
  if(SidebarItems.length > 0) {
     SidebarItems = SidebarItems.map((item)=>{
          if(item.title === 'Documents') {
            return {...item, subMenuItem: [{id: 0, category: 'All'}, ...categories] || []}
          } 
      return item
    });
  }

  const ButtonItem = [
    {
      name: "yes",
      onClick: () => {
        setShowSuccessMessage(false);
        // doLogout();
        localStorage.clear();
        window.location.href = `${window?.location?.origin}/account`;
        ReactGA.set({ userId: "" });
      },
    },
    {
      name: "no",
      onClick: () => {
        setOpen(false);
      },
    },
  ];

  const handleClose = () => {
    setOpen(true);
    setShowSuccessMessage(true);
  };

  const MenuWrapper = styled.div`
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
    display: grid;
    display: flex;
    flex-direction: column;
    gap: 5px 0px;
    text-align: center;
    padding: 20px 0px 30px 15px;
    ::-webkit-scrollbar {
      width: 7px;
    }
    ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
      border-radius: 5px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 6px #ffffff;
      background-color: ${theme.palette.primary.main};
    }

    h1 {
      text-decoration: none;
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      text-align: center;
      color: white;
      text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
      display: grid;
      align-items: center;
      justify-content: center;
    }
     
          .accordion-submenu-item{
    display: flex;
    align-items: center;
    }
   .accordion-item{
       position: relative;
       border:1px solid rgb(231, 231, 232);
       &:hover {
       border:1px solid #000;
    }
   } 
      .accordion-item-border{
        width: 15px;
            border-bottom: 1px solid rgb(231, 231, 232);
        position: absolute;
      }
  .active-icon-deg{
    rotate: 180deg;
  }
    .active-icon{
     position:absolute;
    right:9%;
    top:24%;
    }

    a {
      text-decoration: none;
    }
    a.active h1 {
      color: black;
    }
    .active {
      position: relative;
      background: #fff;
      border-radius: 20px 0px 0px 20px;
      text-align: center;
      display: grid;
      align-items: center;
      justify-content: center;
      padding: 5px;

      ::before,
      ::after {
        content: "";
        width: 20px;
        height: 20px;
        right: 0;
        position: absolute;
      }
      ::before {
        background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg"><path fill="white" fill-opacity="1" d="M0 0 Q20 0 20 20 L20 0Z" /></svg>');
        bottom: -20px;
      }
      ::after {
        background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg"><path fill="rgb(255, 255, 255)" d="M0 20 Q20 20 20 0 L20 20Z" /></svg>');
        top: -20px;
      }
    }
  `;

  const toggleDropdown = (title, event) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    setOpenDropdown((prevTitle) => 
      prevTitle === title ? null : title
    );
  };

  const Wrapper = styled.div`
    ${"" /* margin: 5px 0px 5px 5px; */}
    // padding: 10px;
  width: 330px;
    height: 100vh;
    // position: absolute;
    display: grid;
    grid-template-rows: 1.5fr 10fr;
    background: ${theme.palette.primary.main};
    position: sticky;
    top: 0;
    left: 0;
    @media (max-width: 1130px) {
      width: 330px;
    }
    @media (max-width: 890px) {
      display: none;
    }
        .sub-item-data{
    position:relative;
    margin-left: 20px;
    margin-top: -1px;
    }
  .sub-item-data::after{
    position:absolute;
    width:1px;
    background:rgb(231, 231, 232);
    content: '';
    left:0;
    height:calc(100% - 25px);
    top:0;
    }
    
     .submenu-active{
      padding: 12px 16px;
      // margin-right: 0;
       background: #fff !important;
       border-radius: 20px 20px 20px 20px;
    font-weight: 600 !important;
    color: #000;
}
    .submenu-active::before,
    .submenu-active::after{
   background-image: none;
    }
   `;

  const CategoryLink = styled.div`
    padding: 12px 16px;
    margin: 4px 16px;
    color: white;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    text-decoration: none;
    font-size: 14px;
    display: block;
    transition: all 0.2s;
    position: relative;
   border: 1px solid transparent;
    border-radius: 50px;
    font-weight: 600;
    width:100%;
     border: 1px solid rgba(0, 0, 0);
      border-radius: 50px;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
     
      transition-duration: 2s;
    }
    
    &.active {
      background: #f0f0f0;
      font-weight: 500;
    }
  `;

  return (
    <>
      <Wrapper className="scroll3">
        <Top>
          <NavLink>
            <Image>
             <Logo src={partner?.logo ? partner?.logo : require("../../Assets/Images/Sidebar/pawprint-logo.png")}/>
            </Image>
          </NavLink>
        </Top>
        <MenuWrapper>
          {SidebarItems.map((item, index) => (
            <React.Fragment key={index}>
              <NavLink
                to={item.link}
                activeclassname="active"
                key={index}
                onClick={(event) => {
                  if (item.title === "Documents") {
                    event.preventDefault();
                    event.stopPropagation();
                    toggleDropdown(item.title, event);
                  }
                }}
              >
                <MenuItem
                  style={
                    item?.icon ? { ":hover": { background: "transparent" } } : {}
                  }
                >
                  <h1 style={item?.icon ? { margin: "0px" } : {}}>
                    {item.title}
                    {item?.icon && (
                      <img alt="" src={item.icon} height="40px" width="40px" />
                    )}
                  </h1>
                  {item.title === "Documents" ? <div className={`${openDropdown === item.title ? 'active-icon-deg active-icon' : 'active-icon'}`}><img alt="" src={downArrow}  width="18px"/></div>: ''}
                </MenuItem>
              </NavLink>
              {item.title === "Documents" && openDropdown === item.title && 
              <div className="sub-item-data" onClick={(e) => e.stopPropagation()}>
                {item?.subMenuItem?.map((category, catIndex) =>  {
                    const urlParams = new URLSearchParams(location.search);
                    const categoryId = urlParams.get('categoryId');
                    const isActive = categoryId === String(category.id);
                      return (
                        <div key={catIndex} className="accordion-submenu-item"  onClick={(e) => e.stopPropagation()}>
                          <span className="accordion-item-sub-item">
                                <div className="accordion-item-border"></div>
                              </span>
                          <CategoryLink
                            reloadDocument={false}
                            onClick={(event) => {
                              event.stopPropagation();
                              if (category?.id) {
                                navigate(`/document?categoryId=${category.id}`, { replace: true })
                              } else {
                                navigate(`/document`, { replace: true })
                              }
                            }}
                            key={catIndex}
                            
                            className={isActive || (!categoryId && category.id === 0)? 'submenu-active accordion-item' : 'submenu-item accordion-item'}
                          >
                            {category.category}
                         </CategoryLink>
                          </div>
                        )
                      }
                    )}
              </div>
              }
            </React.Fragment>
          ))}
        </MenuWrapper>
        <Close>
          <Box sx={{ position: "absolute", bottom: "10px", right: "-17px" }}>
            <CloseIcon style={{
                stroke: `${theme.palette.primary.main}`,
                cursor: "pointer",
              }}
              alt="close icon"
              onClick={() => handleClose()}/>
            {/* <closeIcon style={{
                fill: `${theme.palette.primary.main}`,
                cursor: "pointer",
              }}
              alt="delete icon"
              onClick={() => handleClose()}/> */}
            {/* <closeIcon
              style={{
                fill: `${theme.palette.primary.main}`,
                cursor: "pointer",
              }}
              alt="delete icon"
              onClick={() => handleClose()}
            /> */}

          </Box>
        </Close>
        {showSuccessMessage && (
          <DetailsModal
            label="Do you want to logout?"
            open={open}
            buttonList={ButtonItem}
            severity="warning"
            handleClose={() => setOpen(!open)}
          />
        )}
      </Wrapper>
      <Header />
    </>
  );
}

const Top = styled.div`
  display: block;
  margin: auto;
  align-items: center;
  justify-content: center;
`;
const Image = styled.div`
  img {
    margin: auto;
    padding-bottom: 10px;
    @media (max-width: 1130px) {
      width: 180px;
    }
  }
`;

const Close = styled.div`
  position: relative;
  padding: 10px;
  img {
    width: 40px;
    height: 40px;
    transition: 0.8 cubic-bezier(0.075, 0.82, 0.165, 1);
    :hover {
      transform: scale(1.05);
    }
  }
`;
const MenuItem = styled.div`
  width: 240px;
  color: rgba(255, 255, 255, 0.7);
  align-items: center;
  padding: 0px;
  transition: 0.5s ease-out;
  border-radius: 10px;
  justify-items: center;
  border: 1px solid transparent;
  border-radius: 50px;
  position: relative;
  :hover {
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(0, 0, 0);
    border-radius: 10px;
    padding: 0px 0px;
    color: black;
    transition-duration: 2s;
  }
`;
const Logo = styled.img`
    height: auto;
    max-height: 137px;
    border-bottom: 1px solid white; 
    padding-left: 20px;
`;
export default React.memo(Sidebar);
